import { PatientRoute } from "./PatientRoute";
import React from "react";
import { ResultContainer } from "../components/ResultContainer";
import { WelcomeContainer } from "../components/welcomeContainer";
import { Patient1stSummary } from "../components/patient1stSummary";
import { DisclaimerContainer } from "../components/disclaimerContainer";
import { ThanksContainer } from "../components/thanksContainer";
import { ProfileContainer } from "../profile/profileContainer";
import { ChatElementsFrame } from "../components/chatElementsFrame";
import { MoreInfoContainer } from "../components/MoreInfoContainer";

export interface PatientRouteSetting {
  name: string;
  route: PatientRoute | string;
  component: React.ComponentType<any>;
}

interface CreateRouteProps extends PatientRouteSetting {}

const createRoute = ({ name, route, component }: CreateRouteProps) => ({
  name,
  route,
  component,
});

export const PatientRouteSettings: PatientRouteSetting[] = [
  createRoute({
    name: "welcome",
    route: PatientRoute.Welcome,
    component: WelcomeContainer,
  }),

  createRoute({
    name: "chat",
    route: PatientRoute.Questions,
    component: ChatElementsFrame,
  }),

  createRoute({
    name: "disclaimer",
    route: PatientRoute.Disclaimer,
    component: DisclaimerContainer,
  }),

  createRoute({
    name: "result",
    route: PatientRoute.Result,
    component: ResultContainer,
  }),

  createRoute({
    name: "thanks",
    route: PatientRoute.Thanks,
    component: ThanksContainer,
  }),

  createRoute({
    name: "summary",
    route: PatientRoute.Summary,
    component: Patient1stSummary,
  }),

  createRoute({
    name: "moreInfo",
    route: `${PatientRoute.MoreInfo}/:id`,
    component: MoreInfoContainer,
  }),

  createRoute({
    name: "profile",
    route: PatientRoute.Profile,
    component: ProfileContainer,
  }),
];
